import store from '@/stores/store'

const Order = () => import(/* webpackChunkName: "admin" */ '@/components/admin/Orders')
const OrderIndex = () => import(/* webpackChunkName: "admin" */ '@/components/admin/orders/Index')
const OrderShow = () => import(/* webpackChunkName: "admin" */ '@/components/admin/orders/Show')

export default {
  children: [
    {
      component: OrderIndex,
      meta: {
        breadcrumbs: [
          {link: '/admin', name: 'Administração'},
          {name: 'Orders'},
        ]
      },
      path: '/'
    },
    {
      component: OrderShow,
      meta: {
        breadcrumbs: [
          {link: '/admin', name: 'Administração'},
          {link: '/admin/orders', name: 'Orders'},
          {dynamicName: () => store.getters.getNameBreadcrumb, name: 'Show'},
        ]
      },
      path: ':id',
      props: true
    },
  ],
  component: Order,
  path: 'orders',
}
